import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";

/**
 * Reusable bottom-sheet menu for tap-to-edit on mobile.
 * Slides up from the bottom, rounded top corners, drag handle.
 *
 * Props:
 * - open / onOpenChange
 * - title (e.g. "Dinner at Mario's")
 * - subtitle (e.g. "€42.00")
 * - actions: Array<{ icon, label, onClick, danger?: boolean, testId? }>
 */
export const ActionBottomSheet = ({ open, onOpenChange, title, subtitle, actions = [] }) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent
        className="bg-[#1a1a1a] border-t border-border rounded-t-[20px] max-h-[70vh]"
        data-testid="action-bottom-sheet"
      >
        <DrawerHeader className="text-left pb-3">
          {title && <DrawerTitle className="text-base font-medium truncate">{title}</DrawerTitle>}
          {subtitle && <DrawerDescription className="font-mono text-sm text-muted-foreground">{subtitle}</DrawerDescription>}
        </DrawerHeader>
        <div className="px-4 pb-6" style={{ paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}>
          <div className="divide-y divide-border rounded-xl overflow-hidden border border-border bg-foreground/[0.02]">
            {actions.map((a, i) => (
              <button
                key={`${a.label}-${i}`}
                onClick={() => { onOpenChange(false); a.onClick?.(); }}
                className={`w-full flex items-center gap-4 px-4 py-4 text-left transition active:bg-foreground/5 hover:bg-foreground/5 ${
                  a.danger ? "text-red-400" : "text-foreground"
                }`}
                style={{ minHeight: 48 }}
                data-testid={a.testId || `bs-action-${i}`}
              >
                <span className="h-9 w-9 rounded-lg bg-foreground/5 flex items-center justify-center shrink-0">
                  {typeof a.icon === "string" ? <span className="text-base">{a.icon}</span> : a.icon}
                </span>
                <span className="text-sm flex-1">{a.label}</span>
              </button>
            ))}
          </div>
          <button
            onClick={() => onOpenChange(false)}
            className="w-full mt-3 h-12 rounded-xl border border-border text-sm text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition"
            data-testid="bs-cancel"
          >
            Cancel
          </button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
